import React from 'react';

const capitalizeFirstLetter = (text) => {
  if (!text) return text;
  
  return text.replace(/^(<[^>]*>)*([a-z])/i, (match, p1, p2) => 
    (p1 || '') + p2.toUpperCase()
  );
};

export const formatText = (text) => {
  const escapeHtml = (unsafe) => {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/\*/g, "&#42;");
  };

  const escapedText = escapeHtml(text);

  const formattedText = escapedText
    .replace(/&lt;b&gt;(.*?)&lt;\/b&gt;/g, '<strong>$1</strong>')  // Convert <b> to <strong>
    .replace(/&lt;i&gt;(.*?)&lt;\/i&gt;/g, '<i>$1</i>'); // Keep <i> as <i>

  const capitalizedText = capitalizeFirstLetter(formattedText);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: capitalizedText }}
      style={{ wordBreak: 'break-word' }}
    />
  );
};
